import React, { useEffect, useState } from 'react';
import { policyAPI, showApiError } from '../../services/api';
import './PolicyModal.css';
import './PolicyPage.css';

const POLICY_TITLES = {
  TERMS_OF_SERVICE: '서비스 이용약관',
  PRIVACY_POLICY: '개인정보 처리방침',
};

const formatEffectiveDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('ko-KR');
};

const isHtmlContent = (content) => /<[^>]+>/.test(content || '');

const PolicyModal = ({ policyType, onClose }) => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  useEffect(() => {
    let cancelled = false;

    const loadPolicy = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await policyAPI.getActivePolicy(policyType);
        if (!cancelled) {
          setPolicy(data);
        }
      } catch (err) {
        if (!cancelled) {
          showApiError(err, '정책을 불러오지 못했습니다.');
          setPolicy(null);
          setError('정책을 불러오지 못했습니다.');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadPolicy();

    return () => {
      cancelled = true;
    };
  }, [policyType]);

  const title = policy?.title || POLICY_TITLES[policyType] || '정책';

  return (
    <div className="policy-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="policy-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="policy-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="policy-modal-header">
          <div className="policy-modal-header-text">
            <h2 id="policy-modal-title">{title}</h2>
            {policy?.version && (
              <p className="policy-meta">
                버전 {policy.version}
                {formatEffectiveDate(policy.effectiveDate) && (
                  <> · 시행일 {formatEffectiveDate(policy.effectiveDate)}</>
                )}
              </p>
            )}
          </div>
          <button
            type="button"
            className="policy-modal-close"
            onClick={onClose}
            aria-label="닫기"
          >
            ✕
          </button>
        </div>

        <div className="policy-modal-body">
          {loading ? (
            <div className="policy-state">정책을 불러오는 중…</div>
          ) : error ? (
            <div className="policy-state">{error}</div>
          ) : isHtmlContent(policy?.content) ? (
            <article
              className="policy-content policy-html-content policy-modal-content"
              dangerouslySetInnerHTML={{ __html: policy?.content || '' }}
            />
          ) : (
            <article className="policy-content policy-plain-content policy-modal-content">
              {policy?.content}
            </article>
          )}
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;
